import { render, staticRenderFns } from "./GoalsWrapper.vue?vue&type=template&id=28dc8ae0&"
import script from "./GoalsWrapper.vue?vue&type=script&lang=ts&"
export * from "./GoalsWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports